module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    ref: "input",
    staticClass: "search",
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 12
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": _vm.delate
    }
  }, [_vm._v("删除")])], 1)])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序名称",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "SDK版本号",
      "prop": "version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "prop": "u_time"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增投放' : '编辑投放',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "小程序名称",
      "label-width": "120px"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "name",
      "pholder": _vm.form.name
    },
    on: {
      "getid": function (res) {
        _vm.form.issued_app_id = res
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SDK版本号",
      "label-width": "120px"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "version",
      "pholder": _vm.form.version
    },
    on: {
      "getid": function (res) {
        _vm.form.version_id = res
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放时间",
      "label-width": "120px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "default-time": "00:00:00",
      "value-format": "yyyy-MM-dd hh:mm"
    },
    model: {
      value: (_vm.form.u_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "u_time", $$v)
      },
      expression: "form.u_time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61057360"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sdkControl/sdkVersion.vue
// module id = 1107
// module chunks = 2